import { cachedEndpointCall } from '../../services/cached-endpoint/index.tsx';
import { fetchInitialProjectTemplateNameWithRethrow } from '../../services/initial-project-template-name/index.tsx';
import type { FetchInitialProjectTemplateNameArgs } from '../../services/initial-project-template-name/types.tsx';

const fetchInitialProjectTemplateName = cachedEndpointCall(
	(args: FetchInitialProjectTemplateNameArgs) => fetchInitialProjectTemplateNameWithRethrow(args),
);

export const actions = {
	fetchInitialProjectTemplateName,
};
